var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundLighting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.642,
    height: 86.472,
    viewBox: "0 0 73.642 86.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rayo",
    transform: "translate(-202.773 -94.336)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_383",
    "data-name": "Elipse 383",
    cx: 36.821,
    cy: 36.821,
    r: 36.821,
    transform: "translate(202.773 100.751)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_384",
    "data-name": "Elipse 384",
    cx: 31.34,
    cy: 31.34,
    r: 31.34,
    transform: "translate(208.255 106.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6795",
    "data-name": "Trazado 6795",
    d: "M281.712,121.2h-14.7L279.349,84.72,239.33,134.708h14.7l-12.333,36.483Z",
    transform: "translate(-20.927 9.616)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1603",
    "data-name": "Rect\\xE1ngulo 1603",
    width: 6.196,
    height: 69.69,
    transform: "translate(266.422 160.008) rotate(135)",
    fill: "#263238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundLighting);
export default __webpack_public_path__ + "static/media/not-found-lighting.465f8e330c981023723811311a4bfb74.svg";
export { ForwardRef as ReactComponent };